export function normalizeLikesCount(value: unknown, fallback = 0) {
	const count = Number(value);
	if (!Number.isFinite(count)) return Math.max(0, Math.trunc(fallback));
	return Math.max(0, Math.trunc(count));
}

export function formatLikes(count: number) {
	const normalized = normalizeLikesCount(count);
	const suffix = normalized === 1 ? "like" : "likes";
	return `${new Intl.NumberFormat("en-US").format(normalized)} ${suffix}`;
}
